module.exports = __webpack_public_path__ + "static/media/game-display-3@768.24c6bd97.png";